<div class="card">
  <div class="card-body">
    <h5>{{ "DANH SÁCH ĐƠN TẶNG LOA HỘ KINH DOANH" | translate }}</h5>

    <!-- Chart -->
    <!-- <div class="row mb-4">
      <div class="col-md-8">
        <div class="card-custom p-3 border rounded">
          <h6 class="mb-3">{{ 'Thống kê đơn tặng theo gói' | translate }}</h6>
          <apx-chart
            [series]="chartOptions.series"
            [chart]="chartOptions.chart"
            [plotOptions]="chartOptions.plotOptions"
            [dataLabels]="chartOptions.dataLabels"
            [xaxis]="chartOptions.xaxis"
            [yaxis]="chartOptions.yaxis"
            [fill]="chartOptions.fill"
            [tooltip]="chartOptions.tooltip"
            [grid]="chartOptions.grid"
          ></apx-chart>
        </div>
      </div>
    </div> -->

    <!-- Filter -->
    <div class="row mb-3">
      <div class="form-group col-md-4">
        <label>{{ "Khoảng ngày" | translate }}</label>
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Chọn khoảng ngày</mat-label>
          <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
            <input
              matStartDate
              formControlName="start"
              placeholder="Ngày bắt đầu"
            />
            <input
              matEndDate
              formControlName="end"
              placeholder="Ngày kết thúc"
            />
          </mat-date-range-input>
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </div>

      <div class="form-group col-md-4">
        <label>{{ "Số điện thoại" | translate }}</label>
        <input
          type="text"
          class="form-control"
          placeholder="{{ 'Nhập số điện thoại' | translate }}"
          [(ngModel)]="filter.phone"
        />
      </div>

      <div class="form-group col-md-4">
        <label>{{ "Số tài khoản" | translate }}</label>
        <input
          type="text"
          class="form-control"
          placeholder="{{ 'Nhập số tài khoản' | translate }}"
          [(ngModel)]="filter.terminalBankAcc"
        />
      </div>

      <div class="form-group col-md-4">
        <label>{{ "Kết quả tặng loa" | translate }}</label>

        <ng-select
          [items]="statusList"
          bindLabel="label"
          bindValue="value"
          [multiple]="true"
          [closeOnSelect]="false"
          [clearable]="true"
          placeholder="Chọn trạng thái"
          [(ngModel)]="filter.verificationStatus"
        >
        </ng-select>
      </div>

      <div class="form-group col-md-4">
        <label>{{ "Phương thức nhận hàng" | translate }}</label>
        <select class="form-control" [(ngModel)]="filter.deliveryMethod">
          <option [ngValue]="null">{{ "Tất cả" | translate }}</option>
          <option value="direct">{{ "Trực tiếp" | translate }}</option>
          <option value="shipper">{{ "Online" | translate }}</option>
        </select>
      </div>

      <div class="form-group col-md-4">
        <label>{{ "Mã giới thiệu" | translate }}</label>
        <input
          type="text"
          class="form-control"
          placeholder="{{ 'Nhập mã giới thiệu' | translate }}"
          [(ngModel)]="filter.referrer"
        />
      </div>

      <div class="form-group col-md-4 d-flex align-items-end pb-1">
        <button class="btn btn-primary mr-2" (click)="submitFilter()">
          {{ "PAGE.REPORT.Search" | translate }}
        </button>
        <button class="btn btn-dark" *ngIf="searching" (click)="clearFilter()">
          {{ "FORM.Clear" | translate }}
        </button>
      </div>
    </div>

    <!-- Actions: Export / Import -->
    <div
      class="d-flex align-items-center mb-3"
      style="gap: 10px"
      *ngIf="role === 'admin' || role === 'partner_operation'"
    >
      <button class="btn btn-outline-success" (click)="exportExcel()">
        <i class="ri-file-excel-2-line mr-1"></i>
        {{ "Xuất báo cáo" | translate }}
      </button>

      <div class="d-flex align-items-center" style="gap: 8px">
        <label class="btn btn-outline-primary mb-0" for="importFile">
          <i class="ri-upload-2-line mr-1"></i>
          {{ "Chọn file import" | translate }}
        </label>
        <input
          id="importFile"
          type="file"
          accept=".xlsx,.xls,.csv"
          class="d-none"
          (change)="onFileChange($event)"
        />
        <span *ngIf="selectedFile" class="text-muted font-size-13">{{
          selectedFile.name
        }}</span>
        <button
          class="btn btn-success"
          *ngIf="selectedFile"
          (click)="importFile()"
        >
          <i class="ri-check-line mr-1"></i>
          {{ "Import" | translate }}
        </button>
      </div>
    </div>

    <!-- Table -->
    <div class="table-responsive">
      <table class="table table-bordered">
        <colgroup>
          <col style="width: 80px" />
          <col style="width: 80px" /> 
          <col style="width: 90px" />
          <col style="width: 100px" />
          <col style="width: 90px" />
          <col style="width: 160px" />
          <col style="width: 140px" />
          <col style="width: 110px" />
          <col style="width: 150px" />
          <col style="width: 200px" />
          <col style="width: 100px" />
          <col style="width: 100px" />
          <col style="width: 100px" />
          <col style="width: 120px" />
          <col style="width: 70px" />
          <col style="width: 120px" />
          <col style="width: 100px" />
          <col style="width: 100px" />
          <col style="width: 100px" />
          <col style="width: 100px" />
          <col style="width: 100px" />
        </colgroup>
        <thead>
          <tr class="bg-table">
            <th>#</th>
            <th>{{ "Thao tác" | translate }}</th>
            <th>Mã đơn</th>
            <th>Ngày tạo</th>
            <th>CIF KH</th>
            <th>Họ tênKH</th>
            <th>Số ĐKKD</th>
            <th>Số điện thoại</th>
            <th>Số tài khoản</th>
            <th>Tên tài khoản</th>
            <th>Phương thức nhận</th>
            <th>Tỉnh</th>
            <th>Mã giới thiệu</th>
            <th>Trạng thái đơn</th>
            <th>STT tặng</th>
            <th>Kết quả tặng loa</th>
            <th>TK không phải HKD</th>
            <th>Không chính chủ</th>
            <th>Chưa xác thực</th>
            <th>Kết quả hậu kiểm</th>
            <th>CIF HKD</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let item of listData; let i = index">
            <!-- 1 -->
            <td>{{ pageSize * (pageIndex - 1) + i + 1 }}</td>
            <td class="table-column">
              <ng-container
                *ngIf="
                  item.orderStatusEng === 'pending_verification' &&
                  role === 'partner_operation'
                "
              >
                <a
                  class="font-size-18 text-success mr-2"
                  ngbTooltip="{{ 'Duyệt' | translate }}"
                  placement="left"
                  (click)="confirmApprove(item.customerOrderId)"
                >
                  <i class="mdi mdi-check-circle"></i>
                </a>
                <a
                  class="font-size-18 text-danger"
                  ngbTooltip="{{ 'Từ chối' | translate }}"
                  placement="left"
                  (click)="confirmReject(item.customerOrderId)"
                >
                  <i class="mdi mdi-close-circle"></i>
                </a>
              </ng-container>
              <ng-container
                *ngIf="
                  item.orderStatusEng?.trim() === 'pending_verification' &&
                  role?.trim() === 'customer service'
                "
              >
                <a
                  class="font-size-18 text-danger"
                  ngbTooltip="{{ 'Huỷ đơn' | translate }}"
                  placement="left"
                  (click)="confirmCancel(item.customerOrderId)"
                >
                  <i class="mdi mdi-close-circle"></i>
                </a>
              </ng-container>
            </td>

            <!-- 2 -->
            <td class="table-column">{{ item.customerOrderId }}</td>

            <!-- 3 -->
            <td class="table-column">
              {{ item.orderCreatedAt | date : "yyyy-MM-dd" }}
            </td>

            <!-- 4 -->
            <td class="table-column">{{ item.cif }}</td>

            <!-- 5 -->
            <td class="table-column">{{ item.userFullName }}</td>

            <!-- 6 -->
            <td class="table-column">{{ item.businessRegistrationNumber }}</td>

            <!-- 7 -->
            <td class="table-column">{{ item.userPhone }}</td>

            <!-- 8 -->
            <td class="table-column">{{ item.terminalBankAcc }}</td>

            <!-- 9 -->
            <td class="table-column">{{ item.terminalBankAccName }}</td>

            <!-- 10 -->
            <td class="table-column">{{ item.deliveryMethod }}</td>

            <!-- 12 -->
            <td class="table-column">{{ item.shippingProvince }}</td>

            <!-- 13 -->
            <td class="table-column">{{ item.referrer }}</td>

            <!-- 14 -->
            <td class="table-column">{{ item.orderStatus }}</td>

            <!-- 15 -->
            <td class="table-column">{{ item.giveAwayOrderIndex || 1 }}</td>

            <!-- 16 -->
            <td>
              <span
                *ngIf="
                  item?.resultGiveAway === 'Tu_choi' ||
                    item?.resultGiveAway === 'Du_dieu_kien' ||
                    item?.resultGiveAway === 'Dang_ki_moi' ||
                    item?.resultGiveAway === 'Chua_du_dieu_kien';
                  else resultGiveAwayDefault
                "
                class="badge font-size-12"
                [ngClass]="{
                  'badge-danger': item?.resultGiveAway === 'Tu_choi',
                  'badge-primary': item?.resultGiveAway === 'Du_dieu_kien',
                  'badge-secondary': item?.resultGiveAway === 'Dang_ki_moi',
                  'badge-warning':
                    item?.resultGiveAway === 'Chua_du_dieu_kien'
                }"
              >
                {{ item?.resultGiveAway }}
              </span>
              <ng-template #resultGiveAwayDefault>{{
                item?.resultGiveAway
              }}</ng-template>
            </td>

            <!-- 17 -->
            <td>
              {{ item.verificationReason === "TK_khong_phai_HKD" ? "1" : "" }}
            </td>

            <!-- 18 -->
            <td>
              {{
                item.verificationReason === "Khong_phai_chinh_chu" ? "1" : ""
              }}
            </td>

            <!-- 19 -->
            <td>
              {{ item.verificationReason === "Chua_xac_thuc" ? "1" : "" }}
            </td>

            <!-- 20 -->
            <td class="table-column">
              <span
                *ngIf="
                  item.verificationStatusEng === 'fail' ||
                    item.verificationStatusEng === 'pass' ||
                    item.verificationStatusEng === 'pending';
                  else verificationStatusDefault
                "
                class="badge font-size-12"
                [ngClass]="{
                  'badge-danger': item.verificationStatusEng === 'fail',
                  'badge-primary': item.verificationStatusEng === 'pass',
                  'badge-secondary': item.verificationStatusEng === 'pending'
                }"
              >
                {{ item.verificationStatusEng }}
              </span>
              <ng-template #verificationStatusDefault>{{
                item.verificationStatusEng
              }}</ng-template>
            </td>

            <!-- 21 -->
            <td class="table-column">{{ item.cifHkd }}</td>
          </tr>

          <tr *ngIf="listData.length === 0">
            <td colspan="21" class="text-center text-muted">
              Không có dữ liệu
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="row justify-content-md-between align-items-md-center mt-2">
      <div class="col-sm-12 col-md-5">
        <div class="dataTables_info mb-2" role="status" aria-live="polite">
          {{ "TABLE.Showing" | translate }}
          {{ pageSize * pageIndex - pageSize + 1 }}
          {{ "TABLE.to" | translate }} {{ pageSize * pageIndex }}
          {{ "TABLE.of" | translate }} {{ totalCount }}
          {{ "TABLE.entries" | translate }}
        </div>
      </div>
      <div
        class="col-sm-12 col-md-5 d-flex align-items-center justify-content-end"
      >
        <div class="text-md-right float-md-right pagination-rounded">
          <ngb-pagination
            [collectionSize]="totalCount"
            [(page)]="pageIndex"
            [pageSize]="pageSize"
            [maxSize]="5"
            [ellipses]="true"
            (pageChange)="fetchData()"
          ></ngb-pagination>
        </div>
        <div class="dataTables_length ml-3">
          <label class="d-inline-flex align-items-center mb-0">
            {{ "TABLE.Show" | translate }}
            <select
              [(ngModel)]="pageSize"
              (ngModelChange)="pageIndex = 1; fetchData()"
              class="custom-select custom-select-sm form-control form-control-sm mx-2"
            >
              <option [ngValue]="10">10</option>
              <option [ngValue]="25">25</option>
              <option [ngValue]="50">50</option>
              <option [ngValue]="100">100</option>
            </select>
            {{ "TABLE.entries" | translate }}
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
